export function normalizeNbaEnumValue(value) {
  return String(value || '').trim().toLowerCase();
}

export function getCanonicalNbaActionType(type) {
  const normalizedType = normalizeNbaEnumValue(type);

  const aliasMap = {
    visit: 'call',
    content: 'content_push',
    forward: 'content_push',
    meeting: 'meeting_invite',
    department_meeting: 'meeting_invite',
    regional_meeting: 'meeting_invite',
  };

  return aliasMap[normalizedType] || normalizedType;
}

export function getNbaActionTypeI18nKey(type) {
  const keyMap = {
    call: 'ai_nba_action_type_call',
    content_push: 'ai_nba_action_type_content_push',
    meeting_invite: 'ai_nba_action_type_meeting_invite',
    meeting_speaker: 'ai_nba_action_type_meeting_speaker',
  };

  return keyMap[getCanonicalNbaActionType(type)] || 'ai_nba_action_type_default';
}

export function getNbaActionTypeIcon(type) {
  const iconMap = {
    call: ['fas', 'calendar-alt'],
    content_push: ['fas', 'newspaper'],
    meeting_invite: ['fas', 'user-plus'],
    meeting_speaker: ['fas', 'microphone'],
  };

  return iconMap[getCanonicalNbaActionType(type)] || ['fas', 'lightbulb'];
}

export function getNbaActionTypeClass(type) {
  return `action-${getCanonicalNbaActionType(type) || 'default'}`;
}

export function getNbaTriggerTypeI18nKey(triggerType) {
  const keyMap = {
    coverage_gap: 'ai_nba_trigger_type_coverage_gap',
    positive_feedback: 'ai_nba_trigger_type_positive_feedback',
    objection_followup: 'ai_nba_trigger_type_objection_followup',
    digital_engagement: 'ai_nba_trigger_type_digital_engagement',
    content_interest: 'ai_nba_trigger_type_content_interest',
    meeting_opportunity: 'ai_nba_trigger_type_meeting_opportunity',
    doctor_dynamic: 'ai_nba_trigger_type_doctor_dynamic',
    sales_trend: 'ai_nba_trigger_type_sales_trend',
  };

  return keyMap[normalizeNbaEnumValue(triggerType)] || '';
}
